import Icon from '../components/Icon.vue'

Icon.register({
  'grin-tongue-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M344 184C330.7 184 320 194.7 320 208S330.7 232 344 232 368 221.3 368 208 357.3 184 344 184zM248 8C111 8 0 119 0 256 0 362.3 67 452.7 161 488 155.4 475.8 152 462.3 152 448V402.5C127.3 386.3 108.5 364.4 104.2 338.7 102.2 326.9 113.5 317.2 124.9 320.8 155.1 330.5 200 336 248 336S340.9 330.5 371.1 320.8C382.6 317.1 393.7 326.9 391.8 338.7 387.5 364.4 368.7 386.3 344 402.5V448C344 462.3 340.6 475.8 335 488 429 452.7 496 362.3 496 256 496 119 385 8 248 8zM192 233L182.5 224.5C167.7 211.3 136.3 211.3 121.5 224.5L112 233C103.5 240.4 90.4 233.3 92.2 222.2 96.2 197 126.4 180.1 152.1 180.1S208 197 212 222.2C213.6 233.3 200.4 240.4 192 233zM344 272C308.7 272 280 243.3 280 208S308.7 144 344 144 408 172.7 408 208 379.3 272 344 272zM293.1 374.6C278.7 368.1 262 376.8 258.5 392.2L256.7 400C254.6 409.2 241.5 409.2 239.4 400L237.6 392.2C234.1 376.8 217.4 368.1 203 374.6 202.1 375 203.3 374.4 184.1 384V447C184.1 482.2 212.1 511.5 247.2 511.9 282.9 512.4 312.1 483.5 312.1 447.9V383.9C292.6 374.3 293.9 375 293.1 374.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-tongue-wink.js
// module id = 7DgL
// module chunks = 144